<template>
<div>
    <div>
        <div class="store">
            <i class="iconfont">&#xe62d;</i>
            <span>{{goodsInfo.o2o_fuwu_organization_name}}</span>
        </div>
        <ul class="cart-item">
            <li class="buy-item">
                <div class="goods-pic"><img :src="goodsInfo.o2o_fuwu_goods_image_url"/></div>
                <div class="goods-info">
                    <dl>
                        <dt class="goods-name"><a>{{goodsInfo.o2o_fuwu_goods_name}}</a></dt>
                        <dd>
                            <div class="spec-default-list" v-if="specDefaultList">
                                <div class="spec-item" :class="{active:item.o2o_fuwu_goods_spec_id==specQuantityList[0].o2o_fuwu_goods_spec_id}" @click="changeSpec(item)" v-for="(item,index) in specDefaultList" :key="index">{{item.o2o_fuwu_goods_spec_name}}</div>
                            </div>
                        </dd>
                        <dd class="quantity-wrapper" v-if="specQuantityList.length">
                            <div class="spec-info">
                                <p class="price">{{specQuantityList[0].o2o_fuwu_goods_spec_price}}元/{{specQuantityList[0].o2o_fuwu_goods_spec_unit}}</p>
                            </div>
                            <div class="ui-number">
                                <div
                                        class="reduce ui-common"
                                        @click.stop="changeQuantity(0,'-')"
                                        v-bind:class="{ 'reduce-opacity': specQuantityList[0].quantity <= 1 }"
                                >
                                    -
                                </div>
                                <input
                                        type="number"
                                        min="1"
                                        class="number"
                                        value="1"
                                        v-model="specQuantityList[0].quantity"
                                        readonly="true"
                                />
                                <div
                                        class="add ui-common"
                                        @click.stop="changeQuantity(0,'+')"
                                >
                                    +
                                </div>
                            </div>
                        </dd>
                    </dl>
                </div>

            </li>
        </ul>
        <div v-if="specQuantityList.length>1">
            <div class="store">
                <i class="iconfont">&#xe631;</i>
                <span>增值服务</span>
            </div>
            <div class="spec-added-list">
                <div v-for="(item,index) in specQuantityList" :key="index">
                    <div v-if="index!=0" class="quantity-wrapper">
                        <div class="spec-info">
                            <p>{{item.o2o_fuwu_goods_spec_name}}</p>
                            <p class="price">{{item.o2o_fuwu_goods_spec_price}}元/{{item.o2o_fuwu_goods_spec_unit}}</p>
                        </div>
                        <div class="ui-number">
                            <div
                                    class="reduce ui-common"
                                    @click.stop="changeQuantity(index,'-')"
                                    v-bind:class="{ 'reduce-opacity': item.quantity <= 0 }"
                            >
                                -
                            </div>
                            <input
                                    type="number"
                                    min="1"
                                    class="number"
                                    value="1"
                                    v-model="item.quantity"
                                    readonly="true"
                            />
                            <div
                                    class="add ui-common"
                                    @click.stop="changeQuantity(index,'+')"
                            >
                                +
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="cart-subtotal">
            <div @click="timePickerVisible=true"><mt-cell class="menu-item" title="预约时间" ><span slot="icon" class="left-icon iconfont">&#xe63c;</span>{{currentTimeText}}<i class="indicator iconfont">&#xe650;</i></mt-cell></div>
            <div class="message">
                <mt-field label="备注" placeholder="订单留言:" type="textarea" v-model="message" @change="changeMessage()"></mt-field>
            </div>
            <checkout-desc class="desc-item" title="合计" :subtitle="totalAmount"></checkout-desc>
        </div>

    </div>
    <!--预约时间-->
    <mt-popup v-model="timePickerVisible" position="bottom">
        <mt-picker :slots="timeSlots" @change="onTimeChange" valueKey="text" showToolbar>
            <div class="toolbar">
                <button class="toolbar-item cancel-item" @click="timePickerVisible=false">取消</button>
                <div class="picker-header">选择时间</div>
                <button class="toolbar-item confirm-item" @click="confirmTime">确定</button>
            </div>
        </mt-picker>
    </mt-popup>
</div>
</template>

<script>
import { Toast, MessageBox } from 'mint-ui'
import CheckoutDesc from './CheckoutDesc'
export default {
  name: 'CheckoutStore',
  data () {
    return {
      totalAmount: '',
      message: '',
      timeSlots: [],
      timePickerVisible: false,
      specDefaultList: [],
      currentTime: '',
      currentTimeText: '',
      timeValues: [],
      specQuantityList: []
    }
  },
  components: {
    CheckoutDesc
  },
  created () {
    let day = []
    for (var i = 0; i < 7; i++) {
      day.push({ value: this.$moment().add(i, 'd').format('YYYY-MM-DD'), text: this.$moment().add(i, 'd').format('MM月DD日（ddd）') })
    }
    this.timeSlots = [
      {
        flex: 1,
        values: day,
        className: 'slot1',
        textAlign: 'right'
      }, {
        flex: 1,
        values: [{ value: '08:00', text: '上午' }, { value: '14:00', text: '下午' }],
        className: 'slot3',
        textAlign: 'left'
      }
    ]
  },
  props: ['goodsInfo', 'specList'],
  watch: {
    goodsInfo: function (val) {
      if (this.goodsInfo) {
        let specInfo = false
        let specAddedList = []
        for (var i in this.specList) {
          if (this.specList[i].o2o_fuwu_goods_spec_type == 0) {
            this.specList[i].quantity = 1
            this.specDefaultList.push(this.specList[i])
          } else {
            this.specList[i].quantity = 0
            specAddedList.push(this.specList[i])
          }
          if (this.specList[i].o2o_fuwu_goods_spec_id == this.goodsInfo.o2o_fuwu_goods_default_spec) {
            specInfo = this.specList[i]
          }
        }
        if (!this.specDefaultList.length) {
          Toast('服务项目不存在')
          this.$router.go(-1)
        }
        this.specQuantityList.push(specInfo)
        if (specAddedList.length) {
          this.specQuantityList = this.specQuantityList.concat(specAddedList)
        }
        this.$emit('changeQuantity', this.specQuantityList)
      }
      this.calcOrder()
    }
  },
  methods: {
    changeSpec (item) {
      this.specQuantityList.splice(0, 1, item)
      this.$emit('changeQuantity', this.specQuantityList)
      this.calcOrder()
    },
    confirmTime () {
      this.currentTimeText = this.timeValues[0].text + ' ' + this.timeValues[1].text
      this.currentTime = this.timeValues[0].value + ' ' + this.timeValues[1].value
      this.$emit('changeTime', this.currentTime)
      this.timePickerVisible = false
    },
    onTimeChange (picker, values) {
      this.timeValues = values
    },

    changeMessage () {
      this.$emit('changeMessage', this.message)
    },
    changeQuantity (index, type) {
      let temp = this.specQuantityList[index]
      if (type == '-') {
        if ((index == 0 && temp.quantity > 1) || (index > 0 && temp.quantity > 0)) {
          temp.quantity = temp.quantity - 1
        }
      } else {
        temp.quantity = temp.quantity + 1
      }
      this.specQuantityList.splice(index, 1, temp)
      this.$emit('changeQuantity', this.specQuantityList)
      this.calcOrder()
    },
    calcOrder () {
      let price = 0
      for (var i in this.specQuantityList) {
        price += this.specQuantityList[i].quantity * this.specQuantityList[i].o2o_fuwu_goods_spec_price
      }
      this.totalAmount = price.toFixed(2)
    }

  }
}
</script>

<style scoped lang="scss">
.store{    position: relative;
    z-index: 1;
    display: block;
    height: 0.9rem;
    padding: 0.5rem;
    font-size: 0.7rem;
    line-height: 0.9rem;
    border-bottom: solid 0.05rem #EEE;
}
.store i{
        display: inline-block;
        width: 0.8rem;
        height: 0.9rem;
        margin-right: 0.2rem;
        vertical-align: middle;
    }
    .cart-item{background-color: #FFF;
        border-bottom: solid 0.05rem #EEE;}
    .buy-item{    display: block;
        position: relative;
        z-index: 1;
        margin-left: 0.5rem;
        padding: 0.5rem 0;}
    .buy-item .goods-pic{display: block;
        width: 2.7rem;
        height: 2.7rem;
        padding: 0.2rem;
        position: absolute;
        z-index: 1;
        top: 0.5rem;
        left: 0;
        border: solid 0.05rem #EEE;
        border-radius: 0.2rem;}
.buy-item .goods-pic img{width: 2.7rem;
    height: 2.7rem;}
.buy-item .goods-info{    display: block;
        vertical-align: top;
        min-height: 3.1rem;
        margin: 0 .5rem 0 3.5rem;
        position: relative;
        z-index: 1;}
.buy-item .goods-info .goods-name a {
    display: block;
    height: 1.4rem;
    font-size: 0.6rem;
    color: #666666;
    line-height: 0.7rem;
    overflow: hidden;
}

 .cart-subtotal{}
.cart-subtotal dl {
    position: relative;
    z-index: 1;
    height: 1rem;
    padding: 0.4rem 0 0;
    font-size: 0;
}
.cart-subtotal dt {
    position: absolute;
    z-index: 1;
    top: 0.4rem;
    left: 0.4rem;
    display: block;
    width: 50%;
    height: 1rem;
    font-size: 0.6rem;
    line-height: 1rem;
}
.cart-subtotal dd {
    height: 1rem;
    margin: 0 0.5rem 0 50%;
    text-align: right;
    font-size: 0.6rem;
    line-height: 1rem;
}
.cart-subtotal .message {
    border-top:1px solid #eee;
    position: relative;
    z-index: 1;
    display: block;
    padding-top: 0.4rem;
}
.desc-item {
    height: 1.5rem;
}
.ui-number {
    height: 1.2rem;
    display: flex;
    border-radius: 0.15rem 0 0 0.15rem;
input,
div {
    height: 1.2rem;
    text-align: center;
    color: #404245;
    display: inline-block;
    padding: 0;
    margin: 0;
    border: 0;
    outline-offset: 0;
}
.ui-common {
    line-height: 1.2rem;
    width: 1.3rem;
    height: 1.2rem;
    border: 1px solid #c7c7cd;
    cursor: pointer;
}
.reduce {
    border-right: 0;
}
.reduce-opacity {
    opacity: 0.4;
}
.add {
    border-left: 0;
}
input[type='number'] {
    width: 1.3rem;
    border: 1px solid #c7c7cd;
    border-radius: 0;
    border-image-width: 0;
    box-shadow: 0;
    vertical-align: bottom;
&:focus {
     outline: none;
 }
}
}
    .quantity-wrapper{display:flex;align-items:center;
        .spec-info{flex:1;font-size:.7rem;
            .price{color:$primaryColor}
        }
        .ui-number{width: 4rem;}
    }
    .spec-default-list{
        .spec-item{display: inline-block;font-size:.6rem;line-height: 1.2rem;border:1px solid #e1e1e1;padding:0 .2rem;margin-bottom: .2rem;margin-right:.2rem;
            &.active{background:$primaryColor;color:#fff;border-color:$primaryColor}
        }
    }
    .spec-added-list{padding:.5rem;border-bottom:solid 0.05rem #EEE}
.toolbar {
    height: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    background-color: #f0f2f5;
    .toolbar-item {
        font-size: .6rem;
        border: none;
        border-radius: 0;
        background-color: #f0f2f5;
    }
    .cancel-item {
        margin-left: 0.5rem;
        color: #4e545d;
    }
    .confirm-item {
        margin-right: 0.5rem;
        color: red;
    }
    .picker-header {
        color: #4e545d;
        line-height: 2rem;
        font-size:.8rem;
    }
}
</style>
